module.exports = __webpack_public_path__ + "static/media/Background_Werde_Tutor_FAQ_Section.40076d91.svg";